import { useEffect } from "react"
import { Providers } from "./app/providers"
import { AppRoutes } from "./app/routes"
import { AppErrorBoundary } from "./components/system/AppErrorBoundary"
import { ErrorOverlay } from "./components/system/ErrorOverlay"
import { installGlobalErrorHandlers } from "./lib/global-error-handlers"
import { initErrorReporter } from "./lib/error-reporter"
import "./index.css"

// Install global error handlers once at module load
installGlobalErrorHandlers()
initErrorReporter()

function App() {
  // Prevent browser from opening files when dropped outside valid drop zones
  useEffect(() => {
    const preventDefaults = (e: DragEvent) => {
      e.preventDefault()
    }

    window.addEventListener("dragover", preventDefaults)
    window.addEventListener("drop", preventDefaults)

    return () => {
      window.removeEventListener("dragover", preventDefaults)
      window.removeEventListener("drop", preventDefaults)
    }
  }, [])

  return (
    <Providers>
      <AppErrorBoundary>
        <AppRoutes />
      </AppErrorBoundary>
      <ErrorOverlay />
    </Providers>
  )
}

export default App
